import React from 'react';
import { StepButton as EdsStepButton } from '@hedtech/react-design-system/core/es/StepProgress';
const StepButton = (props) => (React.createElement(EdsStepButton, Object.assign({}, props)));
export default StepButton;
